<template>
  <div class="ryfp-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            人员分配
            <div class="search-mode">
              <input v-model="search" type="text" class="search-input" placeholder="关键字搜索" @keyup.enter="Search">
              <el-button class="search-btn" icon="el-icon-search" @click="Search" />
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">未分配</li>
                  <li :class="type===1?'active':''" @click="change(1)">已分配</li>
                </ul>
              </el-col>
              <el-col v-loading="loading" :span="19">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="客户名称"
                    width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="type===0" :disable-transitions="true" size="mini" type="danger">待分配</el-tag>
                      <el-tag v-if="type===1" :disable-transitions="true" size="mini">已分配</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订时间"
                    width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-time"></i> {{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="代理品牌"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-collection-tag"></i> {{ scope.row.brands }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="经销商人员分配"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-loading="editLoading">
        <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="75px" size="small">
          <el-form-item label="经销商" prop="clientname">
            <el-input
              v-model="editForm.clientname"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="代理品牌" prop="bids">
            <el-select v-model="editForm.bids" style="width:100%" multiple placeholder="请选择" @change="changeBrand">
              <el-option
                v-for="item in brandList"
                :key="item.brand_id"
                :label="item.brand_name"
                :value="item.brand_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div v-for="(item, index) in editForm.brandInfo" :key="item.key" class="tcf-panel">
            <p class="tcf-panel-header">
              <label>
                <span class="tcf-panel-header-img">
                  <el-image
                    fit="contain"
                    style="height: 20px;width: 40px;"
                    :src="item.imgurl"
                  ></el-image>
                </span>
                <span class="tcf-panel-header-txt">{{ item.name }}</span>
              </label>
            </p>
            <div class="tcf-panel-body">
              <el-form-item label="区域经理" :prop="'brandInfo.' + index +'.areaid'" :rules="brandInfoRules.areaid">
                <UserSelect v-model="item.areaid" :set="item.areaid" :groupid="item.groupid" :userid="user.dUserid"></UserSelect>
              </el-form-item>
              <el-form-item label="销售客服" :prop="'brandInfo.' + index +'.serviceid'" :rules="brandInfoRules.serviceid">
                <UserSelect v-model="item.serviceid" :set="item.serviceid" :groupid="item.groupid" :userid="user.dUserid"></UserSelect>
              </el-form-item>
              <el-form-item label="报价专员" :prop="'brandInfo.' + index +'.offerid'" :rules="brandInfoRules.offerid">
                <UserSelect v-model="item.offerid" :set="item.offerid" :groupid="item.groupid" :userid="user.dUserid"></UserSelect>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="subLoading" @click="submitForm('editForm')">立即提交</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getPersonWaitList, personWaitDetail, addOrEditPersonAssign } from '@/api/work'
import UserSelect from '@/components/UserSelect'

export default {
  name: 'Ryfp',
  components: {
    UserSelect
  },
  data() {
    return {
      search: '',
      type: 0,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editLoading: false,
      subLoading: false,
      brandList: [],
      editForm: {
        clientname: '',
        did: '',
        bids: [],
        brandInfo: [],
        caid: ''
      },
      editRules: {
        clientname: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        bids: [{ required: true, message: '请选择代理品牌，至少一个品牌', trigger: 'change' }]
      },
      brandInfoRules: {
        areaid: [{ required: true, message: '请选择区域经理', trigger: 'change' }],
        serviceid: [{ required: true, message: '请选择销售客服', trigger: 'change' }],
        offerid: [{ required: true, message: '请选择报价专员', trigger: 'change' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getPersonWaitList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.editVisible = true
      this.editLoading = true
      this.editForm.brandInfo = []
      this.editForm.did = row.caid
      this.editForm.caid = row.fid
      personWaitDetail({ type: this.type, id: row.caid, fid: row.fid }).then(response => {
        this.brandList = response.data.brandList
        const oldbids = []
        const oldbrandInfo = []
        for (const b of this.brandList) {
          if (b.is_select === 1) {
            oldbids.push(b.brand_id)
            let areaid = null
            let serviceid = null
            let offerid = null
            for (const u of response.data.userList) {
              if (b.brand_id === u.bid) {
                if (u.areaid != null && u.areaid != 0) {
                  areaid = u.areaid
                }
                if (u.serviceid != null && u.serviceid != 0) {
                  serviceid = u.serviceid
                }
                if (u.offerid != null && u.offerid != 0) {
                  offerid = u.offerid
                }
                break
              }
            }
            oldbrandInfo.push({
              groupid: this.user.dGroupid,
              bid: b.brand_id,
              name: b.brand_name,
              imgurl: b.img_url,
              areaid: areaid,
              serviceid: serviceid,
              offerid: offerid
            })
          }
        }
        this.editForm.brandInfo = oldbrandInfo
        this.editForm.bids = oldbids
        this.editForm.clientname = response.data.dealerName
        this.editLoading = false
      }).catch(() => {
        this.editLoading = false
      })
    },
    changeBrand(val) {
      for (const bid of val) {
        let ishave = false
        for (const b of this.editForm.brandInfo) {
          if (bid === b.bid) {
            ishave = true
            break
          }
        }
        if (!ishave) {
          for (const b of this.brandList) {
            if (bid === b.brand_id) {
              this.editForm.brandInfo.push({
                groupid: this.user.dGroupid,
                bid: b.brand_id,
                name: b.brand_name,
                imgurl: b.img_url,
                areaid: null,
                serviceid: null,
                offerid: null
              })
              break
            }
          }
        }
      }
      const rmoveIndex = []
      for (let i = 0; i < this.editForm.brandInfo.length; i++) {
        let ishave = false
        for (const bid of val) {
          if (bid === this.editForm.brandInfo[i].bid) {
            ishave = true
            break
          }
        }
        if (!ishave) {
          rmoveIndex.push(i)
        }
      }
      if (rmoveIndex.length > 0) {
        for (const index of rmoveIndex) {
          this.editForm.brandInfo.splice(index, 1)
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.subLoading) {
            this.subLoading = true
            let jsonStr = ''
            for (const b of this.editForm.brandInfo) {
              jsonStr += '"quyu-' + b.bid + '":"' + b.areaid + '","xiaoshou-' + b.bid + '":"' + b.serviceid + '","baojia-' + b.bid + '":"' + b.offerid + '",'
            }
            if (jsonStr.length > 0) {
              jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
            }
            const data = {
              bids: this.editForm.bids.join(','),
              jsonStr: jsonStr,
              did: this.editForm.did,
              type: this.type,
              caid: this.editForm.caid
            }
            addOrEditPersonAssign(data).then(response => {
              this.$message({
                message: '人员分配提交成功',
                type: 'success'
              })
              this.subLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.subLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ryfp-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
